import React, { useState } from "react";
import { TextField } from "@material-ui/core";
import axios from "axios";
import { HTTP_STATUSES, STANDARD_ERRORS_WAY } from "../../../utils/consts";
import { parseAxiosError } from "../../../utils/response";
import userAuthenticationConfig from "../../../utils/userAuthenticationConfig";
import Notification from "../notification/Notification";
import TransactionTypeSelect from "../transactions/TransactionTypeSelect";

import DefaultButton from "../../styles/materialButtonStyle";
import MaterialDialog from "../../styles/materialDialog";
import {
  StyledDialogAction,
  StyledDialogContent,
  StyledDialogHead,
  StyledDialogWrapper
} from "../../styles/styledDialog";

const MasterRefillingCreateForm = ({ t, balanceId, setFetch }) => {

  const INITIAL_DATA = {
    "masterBalance": null,
    "amount": null,
    "type": "Payment",
    "twofa": null
  };

  const [postData, setPostData] = useState(INITIAL_DATA);

  const [open, setOpen] = useState(false);
  const [disabled, setDisabled] = useState(false);

  const [notification, setNotification] = useState({
    visible: false,
    type: "",
    message: ""
  });

  const handleClickOpen = (e) => {
    e.stopPropagation();
    setOpen(true);
  };

  const handleClose = () => {
    setPostData(INITIAL_DATA);
    setOpen(false);
  };

  const createRefilling = async () => {
    setDisabled(true);

    const requestData = { ...postData, "masterBalance": balanceId };

    axios.post("/api/master-refillings", requestData, userAuthenticationConfig(false)).then(response => {
      if (response.status === HTTP_STATUSES.HTTP_CREATED) {
        setNotification(
          { ...notification, visible: true, type: "success", message: t("refill.success") });
        setFetch((current) => !current);
        handleClose();
      }
    }).catch(error => {
      parseAxiosError(eval(STANDARD_ERRORS_WAY), notification, setNotification);
    }).finally(() => setDisabled(false));
  };

  return (
    <>
      <Notification
        notification={notification}
        setNotification={setNotification}
      />
      <div className="exchange-fee-head__create">
        <DefaultButton
          color="transparent"
          border="success"
          onClick={handleClickOpen}
        >
          {t("actions.refill")}
        </DefaultButton>
      </div>

      <MaterialDialog
        open={open}
      >
        <StyledDialogWrapper>
          <StyledDialogHead>
            {t("refill.title")}
          </StyledDialogHead>
          <StyledDialogContent>
            <TextField
              id="amount"
              label={t("refill.amount")}
              value={postData.minAmount}
              onChange={(data) => setPostData({ ...postData, "amount": data.target.value })}
              type="number"
            />
            <TransactionTypeSelect
              checkedStatus={postData.type}
              setCheckedStatus={(data) => setPostData({ ...postData, "type": data })}
            />
            <TextField
              id="twofa"
              label={t("refill.twoFa")}
              value={postData.twofa}
              onChange={(data) => setPostData({ ...postData, "twofa": data.target.value })}
              type="number"
            />
          </StyledDialogContent>
          <StyledDialogAction col="2">
            <DefaultButton
              onClick={handleClose}
              color="danger"
              disabled={disabled}
            >
              {t("refill.cancelBtn")}
            </DefaultButton>
            <DefaultButton
              onClick={createRefilling}
              color="success"
              disabled={disabled}
            >
              {t("refill.createBtn")}
            </DefaultButton>
          </StyledDialogAction>
        </StyledDialogWrapper>
      </MaterialDialog>
    </>
  );
};

export default MasterRefillingCreateForm;